<div class="cancel-order dropdown-content-root">
	<div class="dropdown-title">
		<h4 class="title">{{ 'cancelOrder.title' | translate }}</h4>
		<tui-icon
			class="close-icon"
			icon="@tui.x"
			(click)="onCloseDropdown()"
		/>
	</div>

	<div class="details">
		<div class="detail">
			<span class="title">{{ 'cancelOrder.operation' | translate }}</span>
			<span
				class="ticker"
				highlight
				[isPositive]="order()?.side === orderSideEnum.BUY"
				[isNegative]="order()?.side === orderSideEnum.SELL"
				>{{ `cancelOrder.side.${order()?.side}` | translate }}</span
			>
		</div>

		<div class="detail">
			<span class="title">{{ 'cancelOrder.option' | translate }}</span>
			<div class="ticker">
				<span class="text">{{ order()?.option_ticker }}</span>
				<span class="text">{{ order()?.option_strike | price }}</span>
				<span
					class="text"
					highlight
					[isPositive]="order()?.option_type === optionTypeEnum.CALL"
					[isNegative]="order()?.option_type === optionTypeEnum.PUT"
					>{{ order()?.option_type | uppercase }}</span
				>
				<span class="text">{{ order()?.option_date | date: 'dd.MM.yyyy' }}</span>
			</div>
		</div>

		<div class="detail">
			<span class="title">{{ 'cancelOrder.orderType' | translate }}</span>
			<span class="value">{{ 'cancelOrder.types.' + order()?.type | translate }}</span>
		</div>

		@if (isLimitPriceVisible()) {
			<div class="detail">
				<span class="title">{{ 'cancelOrder.limitPrice' | translate }}</span>
				<span class="value">{{ order()?.limit_price | price }}</span>
			</div>
		}

		<div class="detail">
			<span class="title">{{ 'cancelOrder.quantity' | translate }}</span>
			<span class="value">{{ order()?.qty | quantity }}</span>
		</div>

		<div class="detail">
			<span class="title">{{ 'cancelOrder.sharePerContract' | translate }}</span>
			<span class="value">{{ `x ${optionSharesPerContractConstant}` }}</span>
		</div>

		<div class="detail">
			<span class="title">{{ 'cancelOrder.orderDuration' | translate }}</span>
			@if (order()) {
				<span class="value">
					{{
						'cancelOrder.terms.' + (order()?.time_in_force | titleOrderTerm: order()?.extended_hours)
							| translate
					}}
				</span>
			}
		</div>

		<div class="detail">
			<span class="title">{{ 'cancelOrder.sum' | translate }}</span>
			<span class="value">{{ totalAmount() | amount }}</span>
		</div>
	</div>

	<div class="actions">
		<app-button
			appearance="outline"
			size="l"
			(clicked)="onCloseDropdown()"
		>
			{{ 'cancelOrder.no' | translate }}
		</app-button>
		<app-button
			appearance="negative"
			size="l"
			[isLoading]="isLoading()"
			(clicked)="cancelOrder()"
		>
			{{ 'cancelOrder.yes' | translate }}
		</app-button>
	</div>
</div>
